import { type ReactNode } from 'react'

type AssetGridProps = { children: ReactNode }

/**
 * The single grid definition for both asset pages (admin + partner).
 * Breakpoints are desktop-first: 4-across, then 3 (≤1280), 2 (≤1024),
 * 1 (≤640).
 */
export const AssetGrid = ({ children }: AssetGridProps) => (
  <div
    className="grid grid-cols-4 gap-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1"
    data-tst="asset-grid"
  >
    {children}
  </div>
)
